import { IContatoComTelefone } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import {
    AtualizarContatoService,
    CadastrarContatoService,
    DeletarContatoService,
    GetContatoContaService,
    GetInfoContatoService,
    ListarContatosComTelefoneService,
    ListarContatosService,
} from "../../../Services/Geral/Contatos/ContatosService";
import { Controller } from "../../Controller";
import { IContatos } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";

export async function ListarContatosComTelefoneController(idConta: number) {
    return ListarContatosComTelefoneService(idConta).then((res) =>
        res.data.map(
            (contato) =>
                ({
                    ...contato.CONTATO,
                    CONTATOS_TELEFONE: contato.TELEFONES,
                } as IContatoComTelefone)
        )
    );
}

export async function ListarContatosController(
    idConta: number,
    idCaso?: number
) {
    return Controller(ListarContatosService(idConta, idCaso ?? 0));
}

export async function GetInfoContatoController(nrTelefone: string) {
    return Controller(GetInfoContatoService(nrTelefone));
}

export async function GetContatoContaController(IDContato: string) {
    return Controller(GetContatoContaService(IDContato));
}

export async function DeletarContatoController(
    IDContato: number,
    IDConta?: number
) {
    return Controller(DeletarContatoService(IDContato, IDConta));
}

export async function CadastrarContatoController(
    requestBody: IContatos,
    IDConta: number,
    IDRelacaoCliente: number
) {
    return Controller(
        CadastrarContatoService(requestBody, IDConta, IDRelacaoCliente)
    );
}

export async function AtualizarContatoController(
    requestBody: IContatos,
    IDRelacaoCliente: number,
    atualizarUAU: boolean
) {
    return Controller(
        AtualizarContatoService(requestBody, IDRelacaoCliente, atualizarUAU)
    );
}
